<template>
    <h1>Edit Garment Type Details</h1>
    <div id="garmenttype-editor content-section">


      <div class="page-section">

      <div v-if="errorMessage">
        <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-danger">
          An error occurred tyring to save the garment: {{ errorMessage }}
        </div>
      </div>

      <div v-if="success">
        <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-success alert-dismissible fade show">Garment updated</div>
      </div>

      <h2>Garment Settings</h2>
      <div class="row">
        <div class="col-md-12" id="edit-garment">

          <FormKit
              type="form"
              id="edit-garment"
              :actions="false"
          >
            <FormKit
              v-model="garmenttype.garmenttype"
              type="text"
              name="garmenttype"
              id="garmenttype"
              label="Garment type"
              help="Garment type name (customer), must be unique"
              placeholder="garment type name"
              validation="required"
              @blur="patchGarmentType"
            />

            <FormKit
                id="garmenttypeIsActive"
                v-model="garmenttypeIsActive"
                type="toggle"
                on-value-label="Active"
                off-value-label="Not active"
                on-value="1"
                off-value="0"
                name="garmenttypeIsActive"
                label="Is garment type active?"
            />

            <FormKit
                id="ownership"
                v-model="ownership"
                type="toggle"
                on-value-label="Client"
                off-value-label="LaundryRepublic"
                on-value="client"
                off-value="lr"
                name="ownership"
                label="Garment owner"
            />
            <FormKit
                id="garmenttypeIsMasterType"
                v-model="garmenttypeIsMasterType"
                type="toggle"
                on-value-label="Yes"
                off-value-label="No"
                on-value="1"
                off-value="0"
                name="garmenttypeIsMasterType"
                label="Is garment type a master type?"
            />
            <FormKit
                id="requiredImage"
                v-model="requiredImage"
                type="toggle"
                on-value-label="Yes"
                off-value-label="No"
                on-value="1"
                off-value="0"
                name="requiredImage"
                label="Required Photo?"
            />
            <FormKit
                id="garmenttypeIsPermTag"
                v-model="garmenttypeIsPermTag"
                type="toggle"
                on-value-label="Yes"
                off-value-label="No"
                on-value="1"
                off-value="0"
                name="garmenttypeIsPermTag"
                label="Is garment type a permanent tag?"
            />
            <div class="accordion mb-5" id="accordionGarmentTypeDetails">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button class="accordion-button" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    Garment Type Details
                  </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
                     data-bs-parent="#accordionGarmentTypeDetails">
                  <div class="accordion-body">
                  <FormKit
                      v-model="garmenttype.manufacturer"
                      type="text"
                      name="manufacturer"
                      id="manufacturer"
                      label="Garment manufacturer"
                      help="Optional manufacturer name"
                      placeholder="garment manufacturer"
                      @blur="patchGarmentType"
                  />

                  <FormKit
                      v-model="garmenttype.model"
                      type="text"
                      name="model"
                      id="model"
                      label="Garment model"
                      help="Optional model name"
                      placeholder="garment model"
                      @blur="patchGarmentType"
                  />

                  <FormKit
                      v-model="garmenttype.length"
                      type="number"
                      number="integer"
                      name="length"
                      id="length"
                      min="1"
                      step="1"
                      label="Garment length in cm"
                      help="Optional garment length"
                      placeholder="garment length"
                      @blur="patchGarmentType"
                  />

                  <FormKit
                      v-model="garmenttype.width"
                      type="number"
                      number="integer"
                      name="width"
                      id="width"
                      min="1"
                      step="1"
                      label="Garment width in cm"
                      help="Optional garment width"
                      placeholder="garment width"
                      @blur="patchGarmentType"
                  />

                  <FormKit
                      v-model="garmenttype.gsm"
                      type="number"
                      number="integer"
                      name="gsm"
                      id="gsm"
                      min="1"
                      step="1"
                      label="Garment GSM"
                      help="Optional garment grams per square metre when dry"
                      placeholder="garment GSM"
                      @blur="patchGarmentType"
                  />

                  <FormKit
                      v-model="garmenttype.weight_grams"
                      type="number"
                      number="integer"
                      name="weight_grams"
                      id="weight_grams"
                      min="1"
                      step="1"
                      label="Garment weight in grams"
                      help="Optional total garment weight in grams when dry"
                      placeholder="garment weight"
                      @blur="patchGarmentType"
                  />


                    <FormKit
                        v-model="garmenttype.volume"
                        type="number"
                        number="integer"
                        name="volume"
                        id="volume"
                        min="1"
                        step="1"
                        label="Folded volume in cm3"
                        help="Optional volume when dry, used to estimate number of towel holders"
                        placeholder="volume"
                        @blur="patchGarmentType"
                    />

                    <FormKit
                        v-model="garmenttype.maintype_id"
                        type="autocomplete"
                        name="maintype_id"
                        id="maintype_id"
                        label="Garment master type"
                        help="Can be null or hold will hold a garmenttype_id that already exists. This can also be itself. "
                        placeholder="Garment master type"
                        :options="maintypes"
                        :value="garmenttype.maintype_id"
                        open-on-click
                        clear-search-on-open
                    />

                  </div>
                </div>
              </div>

            </div>

          </FormKit>

          <div class="d-flex align-items-center justify-content-between mt-5 mb-2">
            <h2 class="mb-0">Service Prices</h2>
            <router-link
                class="btn btn-outline-secondary"
                :to="{ name: 'ServicePriceLogs', params: { garmenttypeId: garmenttype.id || router.currentRoute.value.params.id } }"
            >
              View service price logs
            </router-link>
          </div>

          <easy-data-table
              :headers="headers"
              :items="serviceprices"
              alternating
              border-cell
              buttons-pagination
          >
            <template #item-operations="item">
              <div class="operation-wrapper">
                <font-awesome-icon
                    icon="trash"
                    size="1x"
                    class="operation-icon delete"
                    title="Delete"
                    @click="deleteServicePrice(item)">
                </font-awesome-icon>

                <font-awesome-icon
                    icon="edit"
                    size="1x"
                    class="operation-icon edit"
                    title="Edit"
                    @click="editServicePrice(item)">
                </font-awesome-icon>

              </div>
            </template>
          </easy-data-table>

          <button type="button" class="btn btn-primary mt-3" data-bs-toggle="modal"
                  data-bs-target="#newServiceModal" @click="initServicePriceForm">
            Add new service price
          </button>

          <h2 class="mt-5">Customers</h2>

            <FormKit
                v-model="customersRestricted"
                off-value-label="No"
                on-value-label="Yes"
                label="Garment type restricted to below customers?"
                type="toggle"
                name="restricted"
                :on-value="1"
                :off-value="0"
            />

            <FormKit
                v-model="selectedCustomers"
                name="customers"
                type="transferlist"
                label="If the garment type is restricted to customers, it will only be available to process orders for customers on the right side"
                source-label="All customers"
                target-label="Customers for garment type"
                source-empty-message="No customers found"
                target-empty-message="No customers assigned"
                :options="searchCustomers"
                :option-loader="refreshSelectedCustomers"
                :transfer-on-select="false"
                searchable
                placeholder="Search customers"
            />

        </div>
      </div>
    </div>
  </div>

  <!-- service price modal  *********************************************************************  -->
  <div class="modal" tabindex="-1" id="newServiceModal" ref="newServiceModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add / update service price</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <ul class="nav nav-tabs" id="servicePriceTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="main-tab" data-bs-toggle="tab"
                      data-bs-target="#main-tab-pane" type="button" role="tab"
                      aria-controls="main-tab-pane" aria-selected="true">Standard Price
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="main-tab" data-bs-toggle="tab"
                      data-bs-target="#calculated-tab-pane" type="button" role="tab"
                      aria-controls="calculated-tab-pane" aria-selected="true">Calculated Price
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pricebands-tab" data-bs-toggle="tab"
                      data-bs-target="#pricebands-tab-pane" type="button" role="tab"
                      aria-controls="pricebands-tab-pane" aria-selected="false">Special Pricebands
              </button>
            </li>

            <li class="nav-item" role="presentation">
              <button class="nav-link" id="customer-pricebands-tab" data-bs-toggle="tab"
                      data-bs-target="#customer-pricebands-tab-pane" type="button" role="tab"
                      aria-controls="customer-pricebands-tab-pane" aria-selected="false">Customer Pricebands
              </button>
            </li>

            <li class="nav-item" role="presentation">
              <button class="nav-link" id="supplier-tab" data-bs-toggle="tab"
                      data-bs-target="#supplier-tab-pane" type="button" role="tab"
                      aria-controls="supplier-tab-pane" aria-selected="false">Supplier
              </button>
            </li>

          </ul>

          <div class="tab-content mt-3" id="servicePriceContent">

            <div class="tab-pane fade show active" id="main-tab-pane" role="tabpanel" aria-labelledby="main-tab" tabindex="0">

              <div v-if="saveMessage" class="alert alert-danger" role="alert">
                {{ saveMessage }}
              </div>

              <div class="mt-3 mb-3">Customer specific garment types will only require a standard price.
                Leave fields on other tabs empty
              </div>
              <FormKit
                  v-model="serviceprice.servicetype_id"
                  type="autocomplete"
                  name="service"
                  label="Find a service to price for this garment"
                  placeholder="Service"
                  :options="servicetypes"
              />

              <FormKit
                  v-model="serviceprice.priceband_standard"
                  type="number"
                  label="Standard price"
                  help="Decimal number in pound sterling"
                  number="float"
                  name="priceband_standard"
                  min="0"
                  max="9999"
                  step="0.01"
              />

              <FormKit
                  v-model="serviceprice.priority"
                  type="number"
                  help="Button position in relation to other garment types"
                  label="Garment button position"
                  name="priority"
                  step="1"
              />

              <FormKit
                  v-model="serviceprice.num_tags"
                  type="number"
                  help="Number of tags to print when processing"
                  label="Number of tags"
                  name="num_tags"
                  step="1"
              />

              <FormKit
                v-model="serviceprice.publicPrice"
                type="toggle"
                on-value-label="Public"
                off-value-label="Not public"
                 :on-value="1"
                 :off-value="0"
                name="publicPrice"
                label="Is service price public? (will be visible on website)"
            />
            </div>


            <div class="tab-pane fade" id="calculated-tab-pane" role="tabpanel" aria-labelledby="calculated-tab" tabindex="0">

              <a href="#" @click="calculatePricebands" class="btn btn-primary mt-3 mb-3" role="button">Calculate from Standard</a>
              <FormKit
                  v-model="serviceprice.priceband_zero"
                  type="number"
                  label="Zero priceband"
                  number="float"
                  name="priceband_zero"
                  min="0"
                  max="9999"
                  step="0.01"
              />

              <FormKit
                  v-model="serviceprice.priceband_halfprice"
                  type="number"
                  label="Half price priceband"
                  number="float"
                  name="priceband_halfprice"
                  min="0"
                  max="9999"
                  step="0.01"
              />

              <FormKit
                  v-model="serviceprice.priceband_15off"
                  type="number"
                  label="15% priceband"
                  number="float"
                  name="priceband_15off"
                  min="0"
                  max="9999"
                  step="0.01"
              />

              <FormKit
                  v-model="serviceprice.priceband_10off"
                  type="number"
                  label="10% priceband"
                  number="float"
                  name="priceband_10off"
                  min="0"
                  max="9999"
                  step="0.01"
              />

              <FormKit
                  v-model="serviceprice.priceband_rendall"
                  type="number"
                  label="Rendall priceband"
                  help="Usually 25% off"
                  number="float"
                  name="priceband_rendall"
                  min="0"
                  max="9999"
                  step="0.01"
              />

              <FormKit
                  v-model="serviceprice.priceband_mof"
                  type="number"
                  label="Mof priceband"
                  help="Usually 20% off"
                  number="float"
                  name="priceband_mof"
                  min="0"
                  max="9999"
                  step="0.01"
              />

            </div>
            <div class="tab-pane fade" id="pricebands-tab-pane" role="tabpanel" aria-labelledby="pricebands-tab" tabindex="0">
              <FormKit
                  v-model="serviceprice.priceband_legacy"
                  type="number"
                  label="Legacy priceband"
                  number="float"
                  name="priceband_legacy"
                  min="0"
                  max="9999"
                  step="0.01"
              />

              <FormKit
                  v-model="serviceprice.priceband_cost"
                  type="number"
                  label="Cost priceband"
                  number="float"
                  name="priceband_cost"
                  min="0"
                  max="9999"
                  step="0.01"
              />

            </div>

            <div class="tab-pane fade" id="customer-pricebands-tab-pane" role="tabpanel" aria-labelledby="customer-pricebands-tab" tabindex="0">

              <FormKit
                  v-model="serviceprice.priceband_voucher_LRSPRING15"
                  type="number"
                  label="LRSPRING15 priceband"
                  number="float"
                  name="priceband_voucher_LRSPRING15"
                  min="0"
                  max="9999"
                  step="0.01"
              />

              <FormKit
                  v-model="serviceprice.priceband_grosvenor"
                  type="number"
                  label="Grosvenor priceband"
                  number="float"
                  name="priceband_grosvenor"
                  min="0"
                  max="9999"
                  step="0.01"
              />

              <FormKit
                  v-model="serviceprice.priceband_axisacuity"
                  type="number"
                  label="axisacuity priceband"
                  number="float"
                  name="priceband_axisacuity"
                  min="0"
                  max="9999"
                  step="0.01"
              />

              <FormKit
                  v-model="serviceprice.priceband_rentchelsea"
                  type="number"
                  label="Rent Chelsea priceband"
                  number="float"
                  name="priceband_rentchelsea"
                  min="0"
                  max="9999"
                  step="0.01"
              />

              <FormKit
                  v-model="serviceprice.priceband_schrodersuniforms"
                  type="number"
                  label="Schroders Uniforms priceband"
                  number="float"
                  name="priceband_schrodersuniforms"
                  min="0"
                  max="9999"
                  step="0.01"
              />

              <FormKit
                  v-model="serviceprice.priceband_soulcycle"
                  type="number"
                  label="Soul Cycle priceband"
                  number="float"
                  name="priceband_soulcycle"
                  min="0"
                  max="9999"
                  step="0.01"
              />

              <FormKit
                  v-model="serviceprice.priceband_tideway_bg"
                  type="number"
                  label="Tideway priceband"
                  number="float"
                  name="priceband_tideway_bg"
                  min="0"
                  max="9999"
                  step="0.01"
              />

              <FormKit
                  v-model="serviceprice.priceband_celebrity"
                  type="number"
                  label="Celebrity priceband"
                  number="float"
                  name="priceband_celebrity"
                  min="0"
                  max="9999"
                  step="0.01"
              />

            </div>


            <div class="tab-pane fade" id="supplier-tab-pane" role="tabpanel" aria-labelledby="supplier-tab" tabindex="0">

              <FormKit
                  v-model="serviceprice.defaultsupplier_id"
                  type="autocomplete"
                  name="defaultsupplier_id"
                  label="Find a default supplier for this service price"
                  placeholder="Supplier"
                  :options="supplierslist"
                  :value="serviceprice.defaultsupplier_id"
                  open-on-click
                  clear-search-on-open
              />

            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary" @click="saveServicePrice">Save changes</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>

import {onMounted, ref, watch} from 'vue'
import { useRouter } from 'vue-router'
import 'bootstrap/dist/css/bootstrap.min.css';
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.js";

import GarmentTypeService from "@/services/GarmentTypeService";
import garmentTypeService from "@/services/GarmentTypeService";

import {setErrors, clearErrors, FormKit} from '@formkit/vue'


const newServiceModal = ref(null);
const router = useRouter();
const success = ref(false);
const errorMessage = ref("");
const saveMessage = ref("");

const headers = [
  { text: "ID", value: "serviceid", sortable: true  },
  { text: "Service Type", value: "servicetype", sortable: true  },
  { text: "Price", value: "priceband_standard", sortable: true  },
  { text: "Supplier", value: "supplier", sortable: true  },
  { text: "Actions", value: "operations" },
];

const selectedCustomers = ref([]); // Initialize as an empty array

let initialCustomers = [];

const garmenttype = ref({
  id: 0,
  garmenttype: "",
  priority: 9999,
  isActive: 0,
  is_maintype: 0,
  permtags: 0,
});

const serviceprice = ref({
  serviceid: null,
  servicetype_id: null,
  priority: 9999,
  num_tags: 1,
  defaultsupplier_id:0,
  publicPrice: 0
});


const servicetypes = ref([]);
const serviceprices = ref([]);
const maintypes = ref([]);
const supplierslist = ref([]);


const calculatePricebands = () => {

  if (!serviceprice.value.priceband_standard) {
    alert("Please enter a standard price first");
    return false;
  }

  serviceprice.value.priceband_zero = 0;
  serviceprice.value.priceband_halfprice = (serviceprice.value.priceband_standard / 2).toFixed(2);
  serviceprice.value.priceband_15off = getPcOff(serviceprice.value.priceband_standard, 15);
  serviceprice.value.priceband_10off = getPcOff(serviceprice.value.priceband_standard, 10);
  serviceprice.value.priceband_rendall = getPcOff(serviceprice.value.priceband_standard, 25);
  serviceprice.value.priceband_mof = getPcOff(serviceprice.value.priceband_standard, 20);
}

const initServicePriceForm = () => {
  serviceprice.value = {
    serviceid: null,
    servicetype_id: null,
    priority: 9999,
    num_tags: 1,
    defaultsupplier_id:0,
    publicPrice: 0
  };
}

const ownership = ref("client")
const garmenttypeIsActive = ref("1")
const customersRestricted = ref("0")
const garmenttypeIsMasterType = ref("0")
const garmenttypeIsPermTag = ref("0")
const requiredImage = ref("0")

// return percent off a value
function getPcOff(value, pc) {
  return (value - (value / 100 * pc)).toFixed(2);
}
/**
 * Add a new service price to the garment type when submitting a modal form
 * @returns {Promise<void>}
 */
const saveServicePrice = async () => {

  let formData = {
    garmenttype_id: garmenttype.value.id,
    servicetype_id: serviceprice.value.servicetype_id,
    priority: serviceprice.value.priority,
    num_tags: serviceprice.value.num_tags,
    publicPrice: serviceprice.value.publicPrice,
    priceband_standard: serviceprice.value.priceband_standard,
    priceband_legacy: serviceprice.value.priceband_legacy,
    priceband_zero: serviceprice.value.priceband_zero,
    priceband_cost: serviceprice.value.priceband_cost,
    priceband_halfprice: serviceprice.value.priceband_halfprice,
    priceband_15off: serviceprice.value.priceband_15off,
    priceband_10off: serviceprice.value.priceband_10off,
    priceband_rendall: serviceprice.value.priceband_rendall,
    priceband_mof: serviceprice.value.priceband_mof,
    priceband_voucher_LRSPRING15: serviceprice.value.priceband_voucher_LRSPRING15,
    priceband_grosvenor: serviceprice.value.priceband_grosvenor,
    priceband_axisacuity: serviceprice.value.priceband_axisacuity,
    priceband_rentchelsea: serviceprice.value.priceband_rentchelsea,
    priceband_schrodersuniforms: serviceprice.value.priceband_schrodersuniforms,
    priceband_soulcycle: serviceprice.value.priceband_soulcycle,
    priceband_tideway_bg: serviceprice.value.priceband_tideway_bg,
    priceband_celebrity: serviceprice.value.priceband_celebrity,
    defaultsupplier_id: serviceprice.value.defaultsupplier_id,
  }

  if (serviceprice.value.serviceid) {
    await GarmentTypeService.updateServicePrice(serviceprice.value.serviceid, formData)
        .then(response => {
          showSuccess()
          closeModal();
          serviceprice.value = {
            serviceid: null,
            servicetype_id: null,
            priority: 9999,
            num_tags: 1,
            defaultsupplier_id:0,
            publicPrice: 0
          };
        })
        .catch(e => {
          saveMessage.value = e.response.data.message;
          console.log(e.response.data.message);
        });
  } else {
    await GarmentTypeService.newServicePrice(formData)
        .then(response => {
          showSuccess()
          closeModal();
          serviceprice.value = {
            serviceid: null,
            servicetype_id: null,
            priority: 9999,
            num_tags: 1,
            defaultsupplier_id:0,
            publicPrice: 0
          };
        })
        .catch(e => {
          console.log(e.response.data.message);
          saveMessage.value = e.response.data.message;
        });
  }

  loadServicePrices(router.currentRoute.value.params.id);
}

const showSuccess = () => {
  success.value = true;
  setTimeout(function () {
    success.value = false;
  }, 5000);
}

/**
 * Delete the selected service price for the current garment type
 * @param item
 * @returns {Promise<void>}
 */
const deleteServicePrice = async (item) => {
  if (!confirm("Do you really want to delete service price " + item.servicepriceid + "?")) {
    return false
  }
  await garmentTypeService.deleteServicePrice(item.serviceid);
  loadServicePrices(router.currentRoute.value.params.id);
}

const editServicePrice = async (item) => {
  garmentTypeService.getServicePrice(item.serviceid)
      .then(response => {

        const sprice = response.data.data.service_price;

        serviceprice.value.serviceid = sprice.serviceid;
        serviceprice.value.servicetype_id = sprice.servicetype_id;
        serviceprice.value.servicetype = sprice.servicetype;
        serviceprice.value.priority = sprice.prioritygp;
        serviceprice.value.num_tags = sprice.numtags;
        serviceprice.value.publicPrice = sprice.publicPrice;
        serviceprice.value.priceband_standard = sprice.priceband_standard;
        serviceprice.value.priceband_legacy = sprice.priceband_legacy;
        serviceprice.value.priceband_zero = sprice.priceband_zero ;
        serviceprice.value.priceband_cost = sprice.priceband_cost ;
        serviceprice.value.priceband_halfprice = sprice.priceband_halfprice ;
        serviceprice.value.priceband_15off = sprice.priceband_15off ;
        serviceprice.value.priceband_10off = sprice.priceband_10off ;
        serviceprice.value.priceband_rendall = sprice.priceband_rendall ;
        serviceprice.value.priceband_mof = sprice.priceband_mof ;
        serviceprice.value.priceband_voucher_LRSPRING15 = sprice.priceband_voucher_LRSPRING15 ;
        serviceprice.value.priceband_grosvenor = sprice.priceband_grosvenor ;
        serviceprice.value.priceband_axisacuity = sprice.priceband_axisacuity ;
        serviceprice.value.priceband_rentchelsea = sprice.priceband_rentchelsea ;
        serviceprice.value.priceband_schrodersuniforms = sprice.priceband_schrodersuniforms ;
        serviceprice.value.priceband_soulcycle = sprice.priceband_soulcycle ;
        serviceprice.value.priceband_tideway_bg = sprice.priceband_tideway_bg ;
        serviceprice.value.priceband_celebrity = sprice.priceband_celebrity ;
        serviceprice.value.defaultsupplier_id = sprice.defaultsupplier_id ;
        openModal();
      })
      .catch(e => {
        console.log(e);
      });
}

const patchGarmentType = async (e) => {
  const thisField = e.target.name
  const formData = {
    [e.target.name]: e.target.value
  };

  GarmentTypeService.patchGarmentType(router.currentRoute.value.params.id, formData)
      .then(response => {
        errorMessage.value = "";
      })
      .catch(e => {
        console.log(e.response);
        setErrors(
            "edit-garment",
            {
              [thisField]: e.response.data.message,
            }
        )
      });
}

/**
 * Updates a garment type name and details
 * @returns {Promise<void>}
 */
const saveGarmentType = async (data, node) => {

  let formData = {
    id: garmenttype.value.id,
    garmenttype: garmenttype.value.garmenttype,
    active: garmenttype.value.isActive,
    manufacturer: garmenttype.value.manufacturer || "",
    model: garmenttype.value.model || "",
    width: garmenttype.value.width || "",
    length: garmenttype.value.length || "",
    gsm: garmenttype.value.gsm || "",
    weight_grams: garmenttype.value.weight_grams || "",
    ownership: garmenttype.value.ownership || "",
    maintype_id: garmenttype.value.maintype_id || "",
  }
  
  GarmentTypeService.updateGarmentType(router.currentRoute.value.params.id, formData)
      .then(response => {
        showSuccess();
        errorMessage.value = "";
      })
      .catch(e => {
        console.log(e.response);
        FormKit.setErrors(
            [],
            {
              garmenttype: e.response.data.message,
            }
        )
      });
}

const preventSubmit = (e) => {
  e.preventDefault();
  return false;
}

/**
 * Perform an API request to find customers based on keyword used on transfer list
 * @param search
 * @returns {Promise<{label: string, value: *}[]|*[]>}
 */
const searchCustomers = async ({search}) => {
  try {
    const response = await GarmentTypeService.searchCustomers(search);
    const res = response.data.data.customers;

    const foundCustomers = res.map((response) => ({
      label: response.firstname + " " + response.surname + " " + response.accountcode,
      value: response.customerid,
    }));


    return foundCustomers
  } catch (e) {
    console.log(e);
    return [];
  }
}

const onSelectedCustomersChange = () => {
  const customerIds = selectedCustomers.value;

  const formData = new URLSearchParams();
  customerIds.forEach(id => {
    formData.append('customer_ids[]', id);
  });

  GarmentTypeService.addCustomerGarmentType(router.currentRoute.value.params.id, formData)
      .then(response => {
        // Nothing to do here unless you would like to log
      })
      .catch(e => {
        console.log("An error occurred trying to update list")
        console.log(e);
      });

  return true
};

const closeModal = () => {
  bootstrap.Modal.getInstance(newServiceModal.value)?.hide();
}
const openModal = () => {
  bootstrap.Modal.getInstance(newServiceModal.value)?.show();
}

/**
 * Load the currently related service prices for the garment type
 * @param garmentTypeId
 */
const loadServicePrices = (garmentTypeId) => {
  GarmentTypeService.getServicePrices(garmentTypeId)
      .then(response => {

        const sprices = response.data.data.service_prices;

        serviceprices.value = sprices.map((response) => {
          return {
            serviceid: response.serviceid,
            servicetype: response.servicetype,
            priceband_standard: response.priceband_standard,
            supplier: (response.supplier != null)? response.supplier.supplier : "n/a"
          }
        })

      })
      .catch(e => {
        console.log(e);
      });
}

const loadGarmentCustomers = async () => {

    /**
     * Initialise the transferlist with previously selected customers for this garment type
     */
    try {
      const response = await GarmentTypeService.getGarmentCustomers(router.currentRoute.value.params.id)

      const customers = response.data.data.customers;
      initialCustomers.value = customers

      const rightSideCustomers = customers.map((response) => ({
        label: response.customer_details.firstname + " " + response.customer_details.surname + " " + response.customer_details.accountcode,
        value: response.customer_details.customerid,
      }));


      // Add the right side customers to the selectedCustomers list
      selectedCustomers.value = [...rightSideCustomers.map(customer => customer.value)];


    } catch (e) {
      console.log(e);
    }

}

/**
 * This is used mainly on page load to make sure the customer ids for the right side are
 * updated with label information queried separately.
 * It gets triggered by :option-loader for each entry separately
 * @param selected
 * @returns {Promise<{label: string, value}>}
 */
const refreshSelectedCustomers = async (selected) => {
  const foundCustomer = initialCustomers.value.find(customer => customer.customer_id === selected);

  if (foundCustomer) {
    return {
      label: foundCustomer.customer_details.firstname + " "
          + foundCustomer.customer_details.surname + " " + foundCustomer.customer_details.accountcode,
      value: selected,
    }
  }
}

watch(garmenttype.value, async (newValue) => {
  const formValue = {
    target: {
      name: "maintype_id",
      value: newValue.maintype_id,
    }
  }
  patchGarmentType(formValue)
}, { deep: true })

const loadGarmentMainTypes = async () => {
  // Get all available garment maintypes
  //maintypes maintype_id for autocomplete
  GarmentTypeService.getGarmentsMainTypes()
      .then(response => {
        const mtypes = response.data.data.maintypes;

        maintypes.value = mtypes.map((response) => {
          return {
            label: response.garmenttype,
            value: response.garmenttypeid,
          }
        });
        maintypes.value.unshift({
          label: " - remove master type - ",
          value: "0"
        });
      })
      .catch(e => {
        console.log(e);
      });
}
onMounted(async () => {

  newServiceModal.value = new bootstrap.Modal('#newServiceModal', {})

  if (initialCustomers.length === 0) {
    await loadGarmentCustomers()
  }

  // Watch for changes in selectedItems and call the function when it changes
  watch(selectedCustomers, onSelectedCustomersChange);

  watch(ownership, async (newValue) => {
    const formValue = {
      target: {
        name: "ownership",
        value: newValue,
      }
    }

    patchGarmentType(formValue)
  })

  watch(garmenttypeIsActive, async (newValue) => {
    const formValue = {
      target: {
        name: "active",
        value: newValue,
      }
    }

    patchGarmentType(formValue)
  })
  watch(garmenttypeIsMasterType, async (newValue) => {
    const formValue = {
      target: {
        name: "is_maintype",
        value: newValue,
      }
    }

    patchGarmentType(formValue)
  })
  watch(requiredImage, async (newValue) => {
    const formValue = {
      target: {
        name: "required_image",
        value: newValue,
      }
    }

    patchGarmentType(formValue)
  })

  watch(customersRestricted, async (newValue) => {
    const formValue = {
      target: {
        name: "restricted",
        value: newValue,
      }
    }

    patchGarmentType(formValue)
  })

  watch(garmenttypeIsPermTag, async (newValue) => {
    const formValue = {
      target: {
        name: "permtags",
        value: newValue,
      }
    }

    patchGarmentType(formValue)
  })
  // Load the garment types which are main types
  loadGarmentMainTypes();

    // Load the services prices currently attached the garment to display in table
  loadServicePrices(router.currentRoute.value.params.id);

  GarmentTypeService.getGarmentType(router.currentRoute.value.params.id)
      .then(response => {
        garmenttype.value.id = response.data.data.garment_type.garmenttypeid;
        garmenttype.value.garmenttype = response.data.data.garment_type.garmenttype;
        garmenttype.value.isActive = response.data.data.garment_type.active;
        garmenttypeIsActive.value = "" + response.data.data.garment_type.active;
        garmenttypeIsMasterType.value = "" + response.data.data.garment_type.is_maintype;
        requiredImage.value = "" + response.data.data.garment_type.required_image;
        garmenttypeIsPermTag.value = "" + response.data.data.garment_type.permtags;

        garmenttype.value.restricted = response.data.data.garment_type.restricted;
        customersRestricted.value  = response.data.data.garment_type.restricted;

        garmenttype.value.priority = response.data.data.garment_type.prioritygt;

        garmenttype.value.manufacturer = response.data.data.garment_type.manufacturer;
        garmenttype.value.model = response.data.data.garment_type.model;
        garmenttype.value.width = response.data.data.garment_type.width;
        garmenttype.value.length = response.data.data.garment_type.length;
        garmenttype.value.volume = response.data.data.garment_type.volume;
        garmenttype.value.gsm = response.data.data.garment_type.gsm;
        garmenttype.value.weight_grams = response.data.data.garment_type.weight_grams;
        garmenttype.value.maintype_id = response.data.data.garment_type.maintype_id;
        garmenttype.value.ownership = response.data.data.garment_type.ownership;
        ownership.value = response.data.data.garment_type.ownership;

      })
      .catch(e => {
        console.log(e);
      });

  // Get all available service type for autocomplete
  GarmentTypeService.getServiceTypes()
      .then(response => {
        const stypes = response.data.data.service_types;

        servicetypes.value = stypes.map((response) => {
          return {
            label: response.servicetype,
            value: response.servicetypeid,
          }
        })
      })
      .catch(e => {
        console.log(e);
      });

  // Get all available suppliers for autocomplete
  GarmentTypeService.getSuppliersList()
      .then(response => {
        const slist = response.data.data.suppliers;

        supplierslist.value = slist.map((response) => {
          return {
            label: response.supplier,
            value: response.supplierid,
          }
        });
        supplierslist.value.unshift({
          label: " - no supplier - ",
          value: "0"
        });
        console.log(supplierslist);
      })
      .catch(e => {
        console.log(e);
      });
})
</script>

<style scoped>
  
</style>